export enum ApplicationTheme {
  Dark = 'dark',
  Light = 'light',
}

export const DEFAULT_APPLICATION_THEME = ApplicationTheme.Light;

export enum ChatBackgroundPattern {
  Brand = 'brand',
  Dusk = 'dusk',
  Breeze = 'breeze',
  Bloom = 'bloom',
}

export enum ChatBackgroundType {
  Pattern = 'pattern',
  Wallpaper = 'wallpaper',
  Custom = 'custom',
}

export enum ChatBackgroundImageSize {
  Original = 'original',
  Preview = 'preview',
  Miniature = 'miniature',
}

export const DEFAULT_CHAT_BACKGROUND_PATTERN = ChatBackgroundPattern.Brand;
